<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="90px">
          <el-form-item label="品类细分" prop="category">
            <el-select v-model="searchForm.category" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in categoryList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="大型号" prop="bigModel">
            <el-select v-model="searchForm.bigModel" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in bigModeList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款时间" prop="payTime">
            <form-date-range
              :form="searchForm"
              startKey="payTimeStart"
              endKey="payTimeEnd"
              :usingTime="false"
              valueFormat="yyyy-MM-dd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table :data="tableData.records" ref="tableRef" border :height="maxTableHeight" @sort-change="handleSortChange" v-loading="loading">
        <el-table-column
          v-for="(item, index) in columnData"
          :key="index"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.displayName === '图片'">
              <el-button
                v-if="scope.row.imgList && scope.row.imgList.length"
                size="mini"
                type="text"
                @click="viewImg(scope.row)"
                >查看</el-button
              >
            </template>
            <template v-else-if="item.columnName == 'bigModel'">
              <el-tag type="danger" size="mini" v-if="scope.row.stateTag">异常</el-tag>
              <el-button type="text" @click="bigModelClick(scope.row)">{{ scope.row[item.columnName] }}</el-button>
            </template>
            <template v-else-if="item.displayName.includes('销量') && !item.displayName.includes('同比')">
              <el-button type="text" @click="storeLog(scope, '销量')">{{ scope.row[item.columnName] }}</el-button>
            </template>
            <template v-else-if="(item.displayName.includes('金额') || item.displayName.includes('销售额')) && !item.displayName.includes('同比')">
              <el-button type="text" @click="storeLog(scope, '金额')">{{ scope.row[item.columnName] }}</el-button>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <store-sales-dialog :visible.sync="dialogVisible" v-if="dialogVisible" :rowData="rowData" @success="onSearch" />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import storeSalesDialog from "./storeSales.vue";
import imgShow from '@/views/components/imgShow';
import moment from "moment";

export default {
  name: "KeyProductMonitoring",
  mixins: [tableMixin, pagePathMixin],
  components: { storeSalesDialog, imgShow },
  data() {
    return {
      searchForm: {
        payTimeStart: moment(new Date()).subtract(6, "months").format("YYYY-MM-DD"),
        payTimeEnd: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
        bigModel: "",
      },
      tableHeight: 0,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      rowData: {},
      loading: false,
      imgFormVisible: false,
      searchFormData: {},
      imgList: [],
      columnData: [],
      orderDto: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      bigModeList: [],
      categoryList: [],
      dialogType: 1,
      reportName: "QualityCheckPreliminaryReview",
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSort();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          pageSize: this.tableData.pageSize,
          pageNum: this.tableData.pageNum,
          ...this.orderDto,
        },
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
      };
      this.searchFormData = data;
      this.getCategoryList();
      this.getBigModeList();
      this.$q.productModelDetails
        .keyProductsMonitorSearch({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.columnData = res.data.titleList.map((v) => {
              return {
                ...v,
                displayName: v.titleName,
                columnName: v.propertyName,
                displayWidth: "150px",
                sortable: v.sortable == 1 ? "custom" : false,
                span: false,
                freezeType: v.fixed == "1" ? "left" : false,
              };
            });
            // this.dynamicCustomColumn();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(true);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(true);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      let type = order === "ascending" ? "asc" : order === "descending" ? "desc" : false;
      this.tableData.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === "ascending" ? "asc" : order === "descending" ? "desc" : "",
      };
      this.orderDto = type ? this.orderDto : {};
      this.init();
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      let path = row.imgList[0].path
      this.imgList = path.split(';');
    },
    storeLog(scope, type) {
      this.rowData = {
        productCode: scope.row.productCode,
        payMonth: scope.column.property,
        planTimeStart: this.searchForm.payTimeStart,
        planTimeEnd: this.searchForm.payTimeEnd,
        bigModel: scope.row.bigModel,
        category: scope.row.category,
        type: type,
      };
      this.dialogVisible = true;
    },
    bigModelClick(row) {
      this.openSubPage({
        path: '/productSalesData',
        query: {
          bigModel: row.bigModel
        }
      })
    },
    // 导出
    exportExcel(val) {
      const _this = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        ...this.searchFormData,
      };
      this.$q.productModelDetails.keyProductsMonitorExport({ data: data }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == "执行完成") {
                clearInterval(timer);
                loading.close();
                // let filePath = JSON.parse(res.data.filePath);
                // filePath.forEach((data, index) => {
                //   setTimeout(() => {
                    _this.downloadRes(res.data.filePath, '重点品监控');
                  // }, index * 200);
                // });
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },

    //大型号
    getBigModeList() {
      this.$q.productModelDetails.keyProductsListBigModelOptions({ data: this.searchFormData }).then((res) => {
        this.bigModeList = res.data;
      });
    },
    //品类细分
    getCategoryList() {
      this.$q.productModelDetails.keyProductsListCategoryOptions({ data: this.searchFormData }).then((res) => {
        this.categoryList = res.data;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
body {
  height: auto !important
}
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
